import { Scrollbar } from 'react-scrollbars-custom';
import classes from './Addons.module.css';

import Modal from '../ui/Modal';
import Image from '../ui/Image';
import AddonsProduct from './AddonsProduct';

function Addons(props) {
	return (
		<Modal>
			<div className={classes.heading}>
				<div className={classes.added}>
					<div className={classes.image}>
						<Image
							key={props.product.id}
							id={props.product.id}
							name={props.product.name}
							filename={props.product.media.img[0].filename}
							filetype={props.product.media.img[0].filetype}
							filename_webp={props.product.media.img[0].filename_webp}
						/>
					</div>
				</div>
				<div className={classes.callout}>
					<h3>These items are <br/>frequently purchased together:</h3>
				</div>
				<a className={classes.close} onClick={() => props.closeAddons()}><i className={"fa fa-times"}></i></a>
			</div>
			<Scrollbar style={{ width: 800, height: 415 }} noScrollY>
				<div className={classes.container + " " + `${props.addons.length > 3 ? "" : classes.few}`}>
						<div className={`${props.addons.length > 3 ? classes.shadow + " " + classes.left : ""}`}></div>
						{props.addons.map((product, index) => (
							<div className={classes.item}>
								<AddonsProduct
									key={index}
									product={product}
								/>
							</div>
						))}
						<div className={`${props.addons.length > 3 ? classes.shadow + " " + classes.right : ""}`}></div>
				</div>
			</Scrollbar>
			<div className={classes.cartLink}>
				<a href="/cart" className={"btn btn-warning"}>
					<span className={"glyphicon glyphicon-shopping-cart"}></span>
					<span>Check out your cart</span>
				</a>
			</div>
		</Modal>
	);
}

export default Addons;